export default function initializePostList() {
  const filterForms = document.querySelectorAll('.block-post-list__filter-form');
  
  filterForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      const select = form.querySelector('select[name="filter_category"]');
      const selectedValue = select.value;
      
      // Jeśli wybrano "Wszystkie" (value="0"), przekieruj na URL bez parametru filter_category
      if (selectedValue === '0') {
        e.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.delete('filter_category');
        url.searchParams.delete('paged'); // Resetuj też paginację
        window.location.href = url.toString();
        return false;
      }
    });
  });
}
